import { Record } from "immutable";

const defaults = {
    displayName: undefined,
    id: undefined,
    isEditable: undefined,
    isEncrypted: undefined,
    required: undefined,
    name: undefined,
    prerequisiteField: undefined,
    type: undefined,
    validValues: undefined,
};

export class Field extends Record(defaults) {
    declare displayName: string;
    declare id: string;
    declare isEditable: boolean;
    declare isEncrypted: boolean;
    declare required: boolean;
    declare name: string;
    declare prerequisiteField: string | null;
    declare type: string;
    declare validValues: any[] | null;

    constructor(args) {
        super({
            ...args,
            displayName: args.display_name,
            isEditable: args.is_editable,
            isEncrypted: args.is_encrypted,
            required: args.is_required,
            prerequisiteField: args.prerequisite_field,
            validValues: args.valid_values ? args.valid_values : [],
        });
    }
}
